import React from 'react';

import { Box, BoxProps } from '@chakra-ui/react';

interface BorderedBoxProps extends BoxProps {
  children: React.ReactNode;
}

export const BorderedBox: React.FC<BorderedBoxProps> = props => {
  const { children, ...rest } = props;
  return (
    <Box
      py={3.5}
      px={2.5}
      border="1px solid"
      borderColor="componentBorder"
      borderRadius={8}
      {...rest}
    >
      {children}
    </Box>
  );
};
